import { useUrlFilters } from '@/lib/hooks/useUrlFilters';
import type { SettingsFilters } from '../types';

const defaults: SettingsFilters = {
  page: 0,
  limit: 10,
  s: undefined,
  orderBy: 'createdAt',
  order: 'desc',
  'createdAt.min': undefined,
  'createdAt.max': undefined,
  is_active: undefined,
};

const numberFields: (keyof SettingsFilters)[] = ['limit', 'page'];
const booleanFields: (keyof SettingsFilters)[] = ['is_active'];

export function useSettingsFilters() {
  return useUrlFilters<SettingsFilters>({ defaults, numberFields, booleanFields });
}
